import report_generation_builder_component from "@/components/probaworkflows_base_components/ReportGenerationBuilder/ReportGenerationBuilder.vue";
import report_template_library_component from "@/components/probaworkflows_base_components/ReportTemplateLibrary/ReportTemplateLibrary.vue";

export default {
  name: "GenerateReports",
  components: {
    ReportGenerationBuilder: report_generation_builder_component,
    ReportTemplateLibrary: report_template_library_component,
  },
  data: () => ({
    show_template_library: false,
  }),
  methods: {
    reveal_template_library() {
      this.show_template_library = true;
    },
    go_to_generated_reports() {
      this.$router.push("/generated_reports/");
    },
    go_to_report_templates() {
      this.$router.push("/report_templates/");
    },
  },
};
